import { render, staticRenderFns } from "./AtendimentoHibrido.vue?vue&type=template&id=536ef856&"
import script from "./AtendimentoHibrido.vue?vue&type=script&lang=js&"
export * from "./AtendimentoHibrido.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoHibrido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VAppBar,VFadeTransition,VImg,VMain})
